import { Directive } from '@angular/core';
import { IfCheckoutProcessDirective } from './if-checkout-process.directive';
@Directive({
    selector: '[ifNotCheckoutProcess]'
})
export class IfNotCheckoutProcessDirective extends IfCheckoutProcessDirective {
    protected override check(): boolean {
        return !super.check();
    }
}
